export const convertToRelativePath = (url: string | null | undefined): string => {
  if (!url) {
    return '';
  }

  return url
    .replaceAll('https://www.safesitefacilities.co.uk', '');
};
